import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const PasswordReset = t0 => {
  const $ = _c(3);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Your password has been been changed.</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <NotificationBannerSkeleton title="Success!" body={t1} onClose={onClose} />;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
PasswordReset.propTypes = {
  onClose: PropTypes.func
};
export default PasswordReset;